/**
 * Entradas
 *
 */
import React from 'react'
import { Table, message as Message, Button, Divider, DatePicker, Popconfirm, Input, Icon } from 'antd'
import moment from 'moment'
import View from '../../components/View'
import Cell from '../../components/Cell'
import Crud from '../../components/Crud'
import Api from '../../Api'
import Exception from '../../Exception'
import Adjuntos from './Components/Entrada.Adjuntos'

class Page extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      { title: '# REQUISICIÓN', dataIndex: 'ordenCompra.sRequisicion', width: '10%' },
      { title: '# ORDEN', dataIndex: 'ordenCompra.sConsecutivo', width: '10%' },
      { title: '# ENTRADA', dataIndex: 'sConsecutivo', width: '10%' },
      { title: 'RECIBE', dataIndex: 'recibe.sNombre', width: '30%' },
      { title: 'FECHA', dataIndex: 'dFecha', width: '15%', render: val => moment(val).format('YYYY-MM-DD HH:mm:ss') },
      { title: 'REFERENCIA', dataIndex: 'sReferencia', width: '15%' },
      { title: (<Icon type='block' style={{ fontSize: 20 }} />), dataIndex: 'sConsecutivo', width: '10%', render: (_, record) => (
        <div>
          {record.ordenesPago.length > 0 ? null : (
            <Popconfirm
              title='¿Ingresar a cuentas x pagar?'
              onConfirm={e => this.payRequest(record)}
              okText='Si'
              cancelText='No'
              children={
                <Button size='small' shape='circle-outline' icon='dollar' />
              }
            />
          )}
        </div>
      )}
    ])

    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      search: '',
      data: [],
    }

    this.load = this.load.bind(this)
    this.reload = this.reload.bind(this)
  }

  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    const fecha = moment()
    this.load(
      fecha.startOf('month').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD')
    )
  }

  /**
   * SSolicitar ingreso
   */
  payRequest(record) {
    if (!record || !record.iId) {
      return
    }

    this.setState({ loading: true })

    // actualizar la ui
    const closeLoadings = () =>
      this.setState({ loading: false })

    // invocado al finalizar
    const onFinish = () => {
      closeLoadings()
      Message.success('Ingresado a cuentas x pagar')
      this.load(this.state.inicio, this.state.termino, this.state.search)
    }

    // invocado cuando ocurre algún error
    const onError = error => {
      closeLoadings()

      Message.error(
        (new Exception(error)).toComponent()
      )
    }

    Api.post(`/alm/entradas/${record.iId}/solicitar-pago`)
      .then(onFinish)
      .catch(onError)
  }

  /**
   * Cargar
   */
  async load(inicio = -1, termino = -1, search = '') {
    try {
      if (this.state.loading) {
        return
      }

      this.setState({
        loading: true,
        inicio,
      })

      const likeSearch = {$like: `%${search}%`}
      const filter = search.length > 0 ?
        { $or: [{sConsecutivo: likeSearch}, { sReferencia: likeSearch }] } :
        {
          $and: [{ $whereFn: ['date', ['$AlmEntrada.dFecha$'], { $between: [inicio, termino] }] }]
        }

      const response = await Api.query({
        model: "AlmEntrada",
        attributes: [
          'iId',
          'sConsecutivo',
          'sReferencia',
          'dFecha',
          'dFechaRec',
          'iId_OrdenCompra',
          'iId_UsuarioRecibe'
        ],
        include: [
          {
            as: "ordenCompra", attributes: ['sConsecutivo', 'sRequisicion'],
            include: [
              { "as": 'project', attributes: ['sAlias'] },
            ],
          },
          { as: 'recibe', attributes: ['sNombre'] },
          { as: 'ordenesPago', attributes: ['iId'], required: false,
            where: { iActivo: true }
          },
        ],
        where: {
          iId_Proveedor: Api.getProviderId(),
          iActivo: true,
          sEstado: 'VALIDADA',
          ...filter
        },
        order: [['iId', 'DESC']]
      })

      this.setState({
        data: response.data,
        loading: false,
        inicio,
        termino,
        search,
      })
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   * Reload
   *
   */
  reload() {
    this.load(
      this.state.inicio,
      this.state.termino
    )
  }

  /**
   * Render
   *
   */
  render() {
    const crud = (
      <Crud
        buttons={['reload']}
        onReload={this.reload}
      />
    )

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
          onChange={
            (items, fechas) =>
              this.load(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
                this.state.search,
              )
          }
        />
        <Divider type='vertical' />
        <Input.Search
          placeholder="Buscar"
          style={{ width: 185 }}
          onSearch={value =>
            this.load(this.state.inicio, this.state.termino, value.trim())
          }
          allowClear
        />
        <Divider type='vertical' />
        {crud}
      </div>
    )

    return (
      <View>
        <Adjuntos ref={ref => this.adjuntos = ref} />
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <h1 style={{ margin: 0 }}>Entradas de compra</h1>
          <label>SEGUIMIENTO DE PAGO POR MATERIAL SUMINISTRADO</label>
          <br />

          <Table
            rowKey='iId'
            size='small'
            rowClassName = 'row-pure'
            dataSource={this.state.data}
            columns={this.columns}
            loading={this.state.loading}
            pagination={false}
            title={() => tableTitle}
          />
        </div>
      </View>
    )
  }
}

export default Page
